import { render, staticRenderFns } from "./type3.vue?vue&type=template&id=c7f16b24"
import script from "./type3.vue?vue&type=script&lang=js"
export * from "./type3.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Maintenance projects\\devConfig-web-project\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c7f16b24')) {
      api.createRecord('c7f16b24', component.options)
    } else {
      api.reload('c7f16b24', component.options)
    }
    module.hot.accept("./type3.vue?vue&type=template&id=c7f16b24", function () {
      api.rerender('c7f16b24', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/projectConfig/components/type3.vue"
export default component.exports